import {
  Button,
  Form,
  Modal,
  Select,
} from "antd";
import React, { useState } from "react";
import { toast } from "react-toastify";
import { updateEstadoPago } from "../../../lib/updateInvoicePagoStatus";

const { Option } = Select;

const ModalEditEstadoPago = ({
  show,
  setShow,
  selectedInvoice,
  onSuccess // opcional: para refrescar listado de facturas
}) => {
  console.log(selectedInvoice)
  debugger
  const [estadoPago, setEstadoPago] = useState(selectedInvoice?.estadoPago || "pendiente");
  const [loading, setLoading] = useState(false);

  const notifyAccepted = (estado) => {
    toast.success(`✔️ El estado de pago fue actualizado a "${estado}".`, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: false,
    });
  };

  const handleUpdate = async () => {
    setLoading(true);
    try {
      await updateEstadoPago({
        invoiceId: selectedInvoice._id,
        estadoPago: estadoPago,
      });
      notifyAccepted(estadoPago);
      setShow(false);
      if (onSuccess) onSuccess();
    } catch (error) {
      toast.error("❌ Error al actualizar el estado de pago.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      destroyOnClose
      centered
      open={show}
      width={500}
      onCancel={() => setShow(false)}
      footer={null}
      title="Editar estado de pago"
    >
      <Form layout="vertical">
        <Form.Item label="Nuevo estado de pago">
          <Select
            defaultValue={estadoPago}
            onChange={(value) => setEstadoPago(value)}
          >
            <Option value="pendiente">Pendiente</Option>
            <Option value="pagado">Pagado</Option>
            <Option value="vencido">Vencido</Option>
          </Select>
        </Form.Item>

        <Form.Item>
          <Button type="primary" loading={loading} onClick={handleUpdate}>
            Confirmar
          </Button>
          <Button onClick={() => setShow(false)} style={{ marginLeft: 10 }}>
            Cancelar
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ModalEditEstadoPago;
